export const SET_SETTINGS = 'SET_SETTINGS';

export const setSettings = settings => ({
  type: SET_SETTINGS,
  payload: {
    settings
  }
});
